
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/brands/ellixi/doctorcos",
      function () {
        return require("private-next-pages/brands/ellixi/doctorcos.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/brands/ellixi/doctorcos"])
      });
    }
  